import firebase from '../firebase'
const ENDPOINT = 'https://us-central1-sisredvolucion2020.cloudfunctions.net'
const URLCOLLECTIONPAGINATED = `${ENDPOINT}/getCollectionPaginated`
const URLHISTORIES = `${ENDPOINT}/historiesInspirados`
const URLLOADCSV = `${ENDPOINT}/verifyCourseTaken`
const URLLOADCSVCARGUE = `${ENDPOINT}/cargueMasivo`
const URLSABANA = `${ENDPOINT}/historiesInspirados`
const URLVOLSWOINSP = `${ENDPOINT}/voluntariosSinInspirados`
const URLREPORTEMINTIC = `${ENDPOINT}/reporteMinTic`
const URLREPORTEMINTICINSPIRADOS = `${ENDPOINT}/reporteMinTicInspirados`

const db = firebase.firestore()
const collectionPQR = db.collection('mesaAyuda')

export const obtenerHistoriasInspirados = async (params = null) => {
  let url = `${URLHISTORIES}?`

  if (params) {
    url += paramsEncoderBuilder(params)
  }

  if (params && params.download) { window.location = url; return }

  const response = await fetch(url)

  return response.json()
}

export const obtenerInspirados = async (params) => {
  let url = `${URLCOLLECTIONPAGINATED}?collection=inspirados`

  if (params) {
    url += paramsEncoderBuilder(params)
  }

  if (params.download) { window.location = url; return }

  const response = await fetch(url)

  return response.json()
}

export const obtenerInspiradores = async (params) => {
  let url = `${URLCOLLECTIONPAGINATED}?collection=inspiradores`

  if (params) {
    url += paramsEncoderBuilder(params)
  }

  if (params.download) { window.location = url; return }

  const response = await fetch(url)
  return response.json()
}

export const paramsEncoderBuilder = (params) => {
  let urlParamsEncode = ''
  for (const param in params) {
    if (!param) continue

    switch (param) {
      case 'filters':
        for (const filter in params[param]) {
          if (!params[param][filter]) continue
          urlParamsEncode += `&filters[${filter}]=${params[param][filter]}`
        }
        break
      default:
        urlParamsEncode += `&${param}=${params[param]}`
        break
    }
  }
  return urlParamsEncode
}

export const obtenerMeranis = () => {
  return db.collection('usuarios')
    .where('rol', '==', 'merani')
    .orderBy('nombres', 'asc').get()
}

export const cargarCSV = (data) => {
  let url = `${URLLOADCSV}`

  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ listaInscritos: data })
  })
}

export const cargarCSVCargueMasivo = (data) => {
  let url = `${URLLOADCSVCARGUE}`

  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ listaCargue: data }),
    responseType: 'blob'
  })
}

export const obtenerSabana = async (params = null) => {
  let url = `${URLSABANA}?`

  if (params) {
    url += paramsEncoderBuilder(params)
  }

  if (params && params.download) { window.location = url; return }

  const response = await fetch(url)

  return response.json()
}

export const obtenerReporteVoluntariosSinInspirados = async () => {
  let url = `${URLVOLSWOINSP}?`

  window.location = url
}

export const obtenerReporteMinTic = async () => {
  let url = `${URLREPORTEMINTIC}?`

  window.location = url
}

export const obtenerReporteMinTicInspirados = async () => {
  let url = `${URLREPORTEMINTICINSPIRADOS}?`

  window.location = url
}

export const guardarNuevaPQR = async (pqr) => {
  pqr.correo = pqr.correo.toLowerCase()
  pqr.createdAt = Date.now()

  return collectionPQR.add(pqr)
}
